<template>
  <div class="d-flex">
    <div class="text-nowrap">
      <ul class="list-group">
        <li class="list-group-item">購物車設定</li>
        <li class="list-group-item">
          <div class="d-flex flex-column text-left">
            <a href="#">是否開放購物</a>
            <a href="#">購物說明</a>
            <a href="#">購畢感謝語</a>
          </div>
        </li>
        <li class="list-group-item">
          <div class="d-flex flex-column text-left">
            <a href="#">貨運方式</a>
            <a href="#">付款方式</a>
          </div>
        </li>
        <li class="list-group-item">
          <div class="d-flex flex-column text-left">
            <a href="#">發票設定(營業稅)</a>
            <a href="#">額外費用</a>
          </div>
        </li>
        <li class="list-group-item">
          <div class="d-flex flex-column text-left">
            <a href="#">最低消費限制</a>
            <a href="#">自訂訂單欄位</a>
          </div>
        </li>
        <li class="list-group-item">
          <div class="d-flex flex-column text-left">
            <router-link :to="{name:'fullDiscount'}">滿額折扣區</router-link>
            <router-link :to="{name:'totalDiscount'}">總價再折扣</router-link>
            <router-link :to="{name:'plus'}">加購區設定</router-link>
          </div>
        </li>
      </ul>
    </div>

    <div class="flex-fill ml-2">
        <router-view></router-view>
    </div>

    <!-- <div class="col-10">
      <div class="d-flex flex-column flex-fill text-left">
        <div>
          <ul>
            <li>左側有許多購物車環境的相關的設定<br>建議您盡可能將每個項目入設定一下，愈完整的購物環境可以讓消費者獲得更愉快的購物經驗</li>
            <li>若您想暫時關閉整個網站的購物，請勾選</li>
          </ul>
        </div>
        <div class="d-flex justify-content-center align-items-center" style="width:500px;">
          <div class="d-flex flex-column">
            <b-form-radio name="shoppCartRadioBtn" value="A">開放購物</b-form-radio>
            <b-form-radio name="shoppCartRadioBtn" value="B">全站關閉購物 ( 隱藏所有的訂購按鈕 )</b-form-radio>
            <div class="d-flex justify-content-center">
              <button type="button" class="btn btn-primary">確定</button>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {

};
</script>
<style lang="scss">
// .discount{
//   small{
//     color: dodgerblue;
//   }
//   .discountTitle{
//     background-color: rgb(197, 197, 197);
//   }
// }
// .modal_newDiscount{
//   small{
//     color: dodgerblue;
//   }
// }
</style>
